<template>
  <div class="SettingListItem">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "SettingListItem",
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasPre () {
      return this.hasIcon || this.hasLabel
    },
    hasLabel () {
      return this.label != undefined
    },
    mainStyle () {
      const preWidth = this.hasPre ? ' - 30% - 40px' : '- 40px'
      return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        marginLeft: this.hasPre ? '0px' : '10px',
        width: 'calc(100%' + preWidth + ')',
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.SettingListItem {
  margin: 30px 15px 0;
  padding: 20px;
  background-color: #FFFFFF;
  border: 1px solid #E1DADB;
  border-radius: 12px;
  h2 {
    font-size: 16px;
    color: #4B4344;
    font-weight: bold;
  }
  .configured {
    outline: 1px soid red;
    color: #373737;
    font-size: 12px;
    margin-top: 10px;
  }
  .NormalBtn {
    margin: 20px 0px 0;
    width: 300px;
  }
}
</style>
